import { render, staticRenderFns } from "./CreateAgent.vue?vue&type=template&id=2ad7dad7"
import script from "./CreateAgent.vue?vue&type=script&lang=js"
export * from "./CreateAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports